import React from "react";
import Navbar from "../../Shared/NavBar/Navbar";
import FAQMainContent from "./Components/FAQMainContent";

const FAQ = () => {
  return (
    <div className=" main-wrapper">
      <Navbar />
      <FAQMainContent />
    </div>
  );
};

export default FAQ;
